import React, { useState, useEffect } from 'react';
import './Pages.css';

const ExpiredPolicies = ({ setActiveMenu }) => {
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchExpiredPolicies();
  }, []);

  const fetchExpiredPolicies = async () => {
    try {
      const response = await fetch('https://main.victriedemos.com:3017/api/policies/status/0');
      const data = await response.json();

      if (data.success) {
        setPolicies(data.data);
      } else {
        setError('Failed to load expired policies');
      }
    } catch (err) {
      console.error('Error fetching expired policies:', err);
      setError('Unable to connect to server');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'N/A';
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  const formatCurrency = (amount) => {
    if (!amount) return 'N/A';
    return new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency: 'KES'
    }).format(amount);
  };

  const handleRenewPolicy = (policy) => {
    alert(`Renew policy functionality - Policy: ${policy.PolicyNumber}\n(To be implemented)`);
  };

  const filteredPolicies = policies.filter(policy => {
    if (!searchTerm) return true;
    
    const search = searchTerm.toLowerCase();
    const clientName = (policy.ClientName || '').toLowerCase();
    const policyNumber = (policy.PolicyNumber || '').toLowerCase();
    const registration = (policy.Registration || '').toLowerCase();
    
    return clientName.includes(search) || policyNumber.includes(search) || registration.includes(search);
  });

  if (loading) {
    return (
      <div className="page-container">
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading expired policies...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>⏰ Expired Policies</h1>
          <p className="page-subtitle">Policies that have expired and need renewal</p>
        </div>
        <div className="badge-count danger">{filteredPolicies.length} Expired</div>
      </div>

      {error && (
        <div className="error-banner">
          {error}
        </div>
      )}

      <div className="search-bar">
        <input
          type="text"
          placeholder="🔍 Search by Client Name, Policy Number, or Registration..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        {searchTerm && (
          <button 
            className="clear-search-btn"
            onClick={() => setSearchTerm('')}
          >
            ✕ Clear
          </button>
        )}
      </div>

      <div className="table-container">
        {filteredPolicies.length === 0 ? (
          <div className="empty-state">
            <p>{searchTerm ? `No expired policies found matching "${searchTerm}"` : 'No expired policies found'}</p>
          </div>
        ) : (
          <table className="data-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Policy Number</th>
                <th>Client Name</th>
                <th>Registration</th>
                <th>Product Name</th>
                <th>Cover Type</th>
                <th>Gross Premium</th>
                <th>Expiry Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredPolicies.map((policy, index) => (
                <tr key={policy.Id}>
                  <td>{index + 1}</td>
                  <td className="policy-number">{policy.PolicyNumber || 'N/A'}</td>
                  <td className="client-name">{policy.ClientName}</td>
                  <td>{policy.Registration || 'N/A'}</td>
                  <td>{policy.ProductName || 'N/A'}</td>
                  <td>{policy.CoverType || 'N/A'}</td>
                  <td className="amount">{formatCurrency(policy.GrossPremium)}</td>
                  <td className="expired-date">{formatDate(policy.ExpiryDate)}</td>
                  <td>
                    <button 
                      className="action-icon-btn renew-btn" 
                      title="Renew Policy"
                      onClick={() => handleRenewPolicy(policy)}
                    >
                      🔄
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default ExpiredPolicies;
